import Icon from './Icons';
import { site, linkWhatsApp } from '../config';
import './FaixaUrgencia.css';

const mensagem =
  'Olá, preciso de atendimento urgente. Há uma pessoa presa e gostaria de falar com o *Dr. Felipe Almeida* imediatamente.';

export default function FaixaUrgencia() {
  return (
    <aside className="faixa-urgencia" aria-label="Atendimento de urgência">
      <div className="container faixa-urgencia__interno">
        <div className="faixa-urgencia__texto">
          <Icon name="urgencia" size={26} />
          <div>
            <strong>Prisão em flagrante? As primeiras horas são decisivas.</strong>
            <span>{site.plantao}.</span>
          </div>
        </div>

        <div className="faixa-urgencia__acoes">
          <a
            className="btn btn--claro"
            href={linkWhatsApp(mensagem)}
            target="_blank"
            rel="noopener noreferrer"
          >
            <Icon name="whatsapp" size={18} />
            Atendimento imediato
          </a>
          <a className="faixa-urgencia__telefone" href={`tel:${site.telefoneLink}`}>
            <Icon name="telefone" size={18} />
            {site.celular}
          </a>
        </div>
      </div>
    </aside>
  );
}
